<template lang="html">
  <v-container grid-list-md align-center justify-center pt-0 pl-0 pr-0>
    <ComponentStaticDepartment @activeMenu="activeMenu" />
  </v-container>
</template>

<script>
import ComponentStaticDepartment from "@/components/ComponentStaticDepartment";
export default {
  components: {
    ComponentStaticDepartment,
  },
  data() {
    return {
      active: "",
    };
  },
  methods: {
    gotoLink(link) {
      this.$router.push(link);
    },
    activeMenu(status) {
      this.$emit("activeMenu", status);
    },
  },
};
</script>
